import { image } from "../../components/assets/assets";
import AmpleHireImageTag from "../../components/ample-hire-html-tags/ample-hire-image-tag";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const EntitySignupSuccess = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setTimeout(() => {
      setCountdown(prev => prev - 1);
    }, 1000);

    if (countdown === 0) {
      navigate('/signin');
      localStorage.clear();
    }

    return () => clearTimeout(timer);
  }, [countdown, navigate]);

  return (
    <div className="registration-su-wr">
      <h3 style={{ fontSize: "22px", fontWeight: "700", color: "var(--text-primary)", marginBottom: "16px" }}>Registration Complete</h3>
      <div className="img-rewr">
        <AmpleHireImageTag
          imgSrc={image.entitySignupSuccess}
          altText={"Registration successful"}
        />
      </div>
      <p className="succ-text" style={{ fontSize: "16px", color: "var(--text-secondary)", marginBottom: "8px" }}>Your account has been created successfully.</p>
      <p style={{ fontSize: "14px", color: "var(--text-muted)" }}>Our team will reach out to you shortly to complete the setup.</p>
      <p className="redirect-message" style={{ fontSize: "13px", color: "var(--primary-color)", fontWeight: "600", marginTop: "20px" }}>Redirecting to sign in ({countdown}s)...</p>
    </div>
  );
};

export default EntitySignupSuccess;
